import { AuctionTypeRule } from "Interfaces/auctionNotice";

const enableDefineCollocations = (rule: AuctionTypeRule, hasWinner: boolean) => rule?.generalSettings?.disputa?.novaRodadaDeLancesParaDefinirSegundaColocacaoEmDiante?.habilitar && hasWinner;

export { enableDefineCollocations };
